
import { defineComponent } from 'vue'
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';;

export default defineComponent({
    components: {
        QToolbar,
        QToolbarTitle,
        QBtn, 
        QIcon,
    },
    emits: [
        'onHelpPressed',
        'onChartPressed',
        'onSettingsPressed',
    ],
})
